import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import DateRangePicker from "./DateRangePicker";
import ClinicTransactionView from "./ClinicTransactionView";
import AdminTransactionView from "./AdminTransactionView";
import { DateRange } from "../../types/transactionHistory.types";
import { Receipt } from "lucide-react";

function getDefaultDateRange(): DateRange {
  const now = new Date();
  const startDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-01`;
  const endDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  return { startDate, endDate };
}

export default function TransactionHistoryPage() {
  const { user } = useAuth();
  const [dateRange, setDateRange] = useState<DateRange>(getDefaultDateRange);

  const isAdmin = user?.role?.toLowerCase() === "admin";

  const formatDisplayDate = (range: DateRange) => {
    const start = new Date(range.startDate);
    const end = new Date(range.endDate);
    const opts: Intl.DateTimeFormatOptions = { day: "2-digit", month: "short", year: "numeric" };
    return `${start.toLocaleDateString("en-IN", opts)} — ${end.toLocaleDateString("en-IN", opts)}`;
  };

  return (
    <div className="space-y-5 animate-fadeIn">
      {/* Page header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-lg bg-secondary/10 flex items-center justify-center">
            <Receipt className="w-4.5 h-4.5 text-secondary" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-gray-900">Transaction History</h1>
            <p className="text-xs text-gray-400">{formatDisplayDate(dateRange)}</p>
          </div>
        </div>

        <DateRangePicker value={dateRange} onChange={setDateRange} />
      </div>

      {/* Main content */}
      {isAdmin ? (
        <AdminTransactionView dateRange={dateRange} />
      ) : (
        <ClinicTransactionView dateRange={dateRange} />
      )}
    </div>
  );
}
